// extracted by mini-css-extract-plugin
export var label = "_gn-2";
export var slideContainer = "_gn-0";
export var slider = "_gn-1";